import DuplicatedStructureModal from "./DuplicatedStructureModal";
export default DuplicatedStructureModal;
